// @ts-nocheck
import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import * as CardActions from '../../redux/actions/card.actions';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import CardDetailsRow from './CardDetailsRow.jsx';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import { PERMISSIONS, PERMISSION_ENTITIES } from '../../_config/consts';

@connect(state => ({
  cards: state.cards,
  credentials: state.credentials,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
  privateUnits: state.privateUnit.allPrivateUnits,
}))
class CardsListView extends React.Component {

  
  componentWillUnmount() {
    this.closeOperationalSection();
  }

  appendCards(page) {
    const { dispatch } = this.props;
    const append = true;
    dispatch(CardActions.fetchCards(page, append));
  }

  closeOperationalSection() {
    const { dispatch } = this.props;
    dispatch(CardActions.setOperationalMode(false));
  }

  render() {
    const { cards, onShowInfoModal, privateUnits, onOpenPrivateUnitRequest, listContainerStyle, cards: { selectedCard, cardsData: { pagination: { number: currentPage, totalPages } } }, onSelectCard, onNewCardClick, themeName, viewLoading, onDeleteCardRequest, onCreateCardCredentialFromModel } = this.props;
    const canCreateNewCard = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.CREATE], PERMISSION_ENTITIES.STANDARD_DEVICE);
    return (
      <div className="list-view details-section" style={{ top: 190, paddingBottom: 40, width: '90%', overflow: 'auto', ...listContainerStyle }}>
        <InfiniteScroll
          initialLoad={false}
          loadMore={() => this.appendCards(currentPage + 1)}
          hasMore={currentPage + 1 < totalPages}
          loader={<ListLoadingView />}
          useWindow={false}
        >
          <div className="r-full-width-phone" style={{ width: '40%' }}>
            {!_.isEmpty(cards.cardsData.data) ?
            _.map(cards.cardsData.data, card =>
              <CardDetailsRow
                themeColor={themeName}
                key={card.id}
                isSelected={selectedCard && selectedCard.id === card.id}
                card={card}
                onClick={() => onSelectCard(card)}
                privateUnits={privateUnits}
                onOpenPrivateUnitRequest={(privateUnitId)=>onOpenPrivateUnitRequest(privateUnitId)}
                onDeleteCardRequest={() => onDeleteCardRequest(card)}
                onCreateCardCredentialFromModel={() => onCreateCardCredentialFromModel(card)}
              />)
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noCard"
                    onNewEntity={canCreateNewCard ? () => onNewCardClick() : null}
                    onShowInfo={() => onShowInfoModal()}
                    newEntityTitle="addCard"
                    subtitle="startCreatingCard"
                    iconName="icon-simple-line-icons-credit-card"
                  />) : <ListLoadingView />}
              </div>
            )}
          </div>
        </InfiniteScroll>
      </div>
    );
  }
} 

export default CardsListView;
